import { Fetch } from 'lib';

type RequestResponses = {};

type RequestParameters = {
  id: string;
};

const deleteCatalog = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminCatalog/deleteCatalog',
    method: 'DELETE',
    params,
  });

export { deleteCatalog };
